var html = $('html');

$(function () {
    darkMode();
    carousel();
    hideCommentAvatars()
});

function darkMode() {
    $('.toggle-track').on('click', function () {
        if (html.hasClass('dark-mode')) {
            html.removeClass('dark-mode');
            localStorage.setItem('alto_dark', false);
        } else {
            html.addClass('dark-mode');
            localStorage.setItem('alto_dark', true);
        }
    });
}

function hideCommentAvatars() {
    var iframe = document.getElementById("ghost-comments-root").firstChild
    iframe.addEventListener("load", function() {
        var style = document.createElement('style')
        style.textContent = "div[data-testid='comment-component'] figure > img { display: none; }"
        this.contentDocument.head.appendChild(style)
    });
}

function carousel() {
    var carousel = $('.carousel');
    var postImage = carousel.find('.post-image');
    var imageHeight, nav;

    function moveNav() {
        imageHeight = postImage.height();
        if (!nav) {
            nav = carousel.find('.owl-prev, .owl-next');
        }
        nav.css({
            top: imageHeight / 2 + 'px',
            opacity: 1,
        });
    }

    carousel.owlCarousel({
        dots: false,
        margin: 28,
        nav: true,
        navText: [
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="22" height="22" fill="currentColor"><path d="M20.547 22.107l-6.107-6.107 6.107-6.12-1.88-1.88-8 8 8 8 1.88-1.893z"></path></svg>',
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="22" height="22" fill="currentColor"><path d="M11.453 22.107l6.107-6.107-6.107-6.12 1.88-1.88 8 8-8 8-1.88-1.893z"></path></svg>',
        ],
        onInitialized: function () {
            moveNav();
            carousel.css('visibility', 'visible');
        },
        onResized: function () {
            moveNav();
        },
        responsive: {
            0: {
                items: 1,
            },
            768: {
                items: 3,
            },
            992: {
                items: 4,
            },
        },
    });
}

$(function () {
    var paypalContainer = $('div[data-paypal-id]')
    if (!paypalContainer.length) {
        return
    }

    var paypalSlug = paypalContainer.data('paypal-id')
    if (!paypalSlug) {
        return
    }

    var paypalID = paypalSlug.split('-').pop()

    paypalContainer.find('input[name="business"]').attr('value', paypalID.toUpperCase())
    paypalContainer.removeClass('hidden')
});
